export default __webpack_public_path__ + "static/media/language.ac10ee2b.svg";